document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.accordian-list .Accordian');
  if (accordions.length > 0) {
    accordions.forEach(accordion => {
      const title = accordion.querySelector('.accord-title');

      if (title) {
        if (!title.hasEventListener) {
          title.hasEventListener = true;

          title.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            // Close all other accordions
            accordions.forEach(acc => {
              if (acc !== accordion) {
                acc.classList.remove('is-open');
              }
            });

            // Toggle the clicked accordion
            accordion.classList.toggle('is-open');
          });
        }
      } else {
        console.error('No title element found inside Accordion.');
      }
    });
  } else {
    console.error('No elements with class "Accordian" found.');
  }
});